import React from "react";
import DetailsNotFoundProps from "./DetailsNotFoundProps";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { setCurrentActiveTab } from "../../state/actions/LettersReportsActions";
import emptyMessageIcon from "../../assets/images/message-empty-icon.png";
import arrowRightWhite from "../../assets/images/arrow-white-right.png";
import "./DetailsNotFound.scss";

const DetailsNotFound = (props: DetailsNotFoundProps) => {
  const {
    latestFilterStartDate,
    latestFilterEndDate,
    latestTabValue,
    latestRadioValue,
  } = useSelector((state: any) => state.LettersReportsReducer);
  const dispatch = useDispatch();
  const { t } = useTranslation("common");

  const handleDepositLogic = () => {
    // If receives those props properly from deposits page - set the chips labels.

    if (
      props.setFirstLabel &&
      props.latestFirstLabel &&
      props.setSecondLabel &&
      props.latestSecondLabel &&
      props.latestChip &&
      props.setCurrentChip &&
      props.latestRenderLabel &&
      props.setRenderLabel
    ) {
      props.setFirstLabel(props.latestFirstLabel);
      props.setSecondLabel(props.latestSecondLabel);
      props.setCurrentChip(props.latestChip);
      props.setRenderLabel(props.latestRenderLabel);
    }
  };

  const handleClick = () => {
    // Handle click on back to last successful filter button
    if (props.yearsOnly && props.lastSuccessfulYear) {
      // The filter was by year, set the latest successful year filter
      props.setCurrentActive &&
        props.setCurrentActive(props.lastSuccessfulYear);
    } else {
      if (latestRadioValue === t("LettersReports.radioValue1")) {
        props.setRadioValue &&
          props.setRadioValue(t("LettersReports.radioValue1"));
        latestTabValue.length && dispatch(setCurrentActiveTab(latestTabValue));
      } else if (latestRadioValue === t("LettersReports.radioValue2")) {
        if (
          latestFilterStartDate &&
          latestFilterStartDate !== "" &&
          latestFilterEndDate &&
          latestFilterEndDate !== ""
        ) {
          props.setRadioValue &&
            props.setRadioValue(t("LettersReports.radioValue2"));
          latestTabValue.length &&
            dispatch(setCurrentActiveTab(latestTabValue));
          props.setStartDate && props.setStartDate(latestFilterStartDate);
          props.setEndDate && props.setEndDate(latestFilterEndDate);
        }
      }
      props.latestRenderLabel?.length && handleDepositLogic();
    }
  };

  return (
    <>
      <div className="reports-no-details-found">
        <img src={emptyMessageIcon} alt="" />
        <span className="no-details-found-label" role={props.alertMsg ? "" : "alert"}>
          {t("DetailsNotFound.noDetails")}
        </span>

        {props?.lastSuccessfulYear?.length || latestRadioValue?.length ? (
          <button className="no-details-found-button" onClick={handleClick}>
            <img src={arrowRightWhite} alt="" />
            <span className="no-details-button-label">
              {t("DetailsNotFound.backFilter")}
            </span>
          </button>
        ) : null}
      </div>
    </>
  );
};

export default DetailsNotFound;
